import { createStore } from 'vuex'
import { auth, db } from '../firebaseConfig'
import { onAuthStateChanged } from 'firebase/auth'
import { doc, getDoc } from 'firebase/firestore'

export default createStore({
  state: {
    user: null,
    userRole: null,
    isAuthenticated: false,
    loading: true
  },
  getters: {
    isAuthenticated: state => state.isAuthenticated,
    user: state => state.user,
    userRole: state => state.userRole,
    isAdmin: state => state.userRole === 'Admin',
    isExecutive: state => state.userRole === 'Executive',
    isEmployee: state => state.userRole === 'Employee',
    isManager: state => ['Admin', 'manager'].includes(state.userRole),
    isMember: state => state.userRole === 'member',
    isUser: state => state.userRole === 'user',
    // Both Executive and Admin have full system access
    hasFullAccess: state => ['Admin', 'Executive'].includes(state.userRole)
  },
  mutations: {
    SET_USER(state, user) {
      state.user = user
      state.isAuthenticated = !!user
    },
    SET_USER_ROLE(state, role) {
      state.userRole = role
    },
    SET_LOADING(state, loading) {
      state.loading = loading
    },
    LOGOUT(state) {
      state.user = null
      state.userRole = null
      state.isAuthenticated = false
    }
  },
  actions: {
    async initAuth({ commit }) {
      return new Promise((resolve) => {
        onAuthStateChanged(auth, async (user) => {
          if (user) {
            commit('SET_USER', user)
            try {
              await this.dispatch('fetchUserData', user.uid)
            } catch (error) {
              // If user is inactive, logout and clear state
              commit('LOGOUT')
            }
          } else {
            commit('LOGOUT')
          }
          commit('SET_LOADING', false)
          resolve()
        })
      })
    },
    async fetchUserData({ commit }, uid) {
      try {
        // Try users collection first
        let userDoc = await getDoc(doc(db, 'users', uid))
        
        if (!userDoc.exists()) {
          // If not found in users, try members collection
          userDoc = await getDoc(doc(db, 'members', uid))
        }
        
        if (userDoc.exists()) {
          const userData = userDoc.data()
          
          // Check if user is active
          console.log('Checking user status:', userData.status)
          if (userData.status !== 'active') {
            console.log('User is inactive, logging out')
            // Clear the state immediately
            commit('LOGOUT')
            // Sign out from Firebase
            await auth.signOut()
            throw new Error('User account is inactive')
          }
          
          commit('SET_USER_ROLE', userData.role)
          console.log('User role set:', userData.role)
        } else {
          console.log('No user data found')
          commit('SET_USER_ROLE', null)
        }
      } catch (error) {
        console.error('Error fetching user data:', error)
        commit('SET_USER_ROLE', null)
        throw error
      }
    },
    async logout({ commit }) {
      try {
        // Set loading state to prevent multiple logout attempts
        commit('SET_LOADING', true)
        
        // Stop session tracking if it exists
        if (window.sessionManager) {
          window.sessionManager.stopSessionTracking()
        }
        
        // Sign out from Firebase
        await auth.signOut()
        
        // Clear the state
        commit('LOGOUT')
        
        // Reset loading state
        commit('SET_LOADING', false)
      } catch (error) {
        console.error('Error signing out:', error)
        // Even if there's an error, clear the state
        commit('LOGOUT')
        commit('SET_LOADING', false)
      }
    }
  },
  modules: {
  }
})
